import { useActiveMenuElements } from '@/composables/menu'
import { usePage } from '@inertiajs/vue3'

/**
 * Customer navigation preferences (Marketplace concept §7, R7 part B). The server resolves the
 * event override, the company default and „visible" (App\Domain\Module\Services\MenuVisibility)
 * and shares the entries to leave out as `_navigation.hidden`. Cosmetic only: a hidden entry is
 * missing from the menus, its pages, section tabs and direct URLs keep working.
 */

/** @returns {string[]} */
export const hiddenMenuEntries = () => usePage().props._navigation?.hidden ?? []

/**
 * @param {string|undefined} navKey an entry's key (menu.js `navKey`, MenuEntry on the server)
 * @returns {boolean}
 */
export const isMenuEntryHidden = (navKey) =>
  Boolean(navKey) && hiddenMenuEntries().includes(navKey)

/**
 * The event menu the sidebars and the mobile menu show: useActiveMenuElements without the hidden
 * entries. The section tabs keep using useActiveMenuElements, so a hidden section still has its
 * tabs when opened by URL.
 *
 * @returns {Array<object>}
 */
export const useVisibleMenuElements = () =>
  useActiveMenuElements().filter((menu) => !isMenuEntryHidden(menu.navKey))
